import { useEffect, useRef } from 'react';

function useFetchOnScroll({
  getMoreHorizontalCategoryActn,
  currentCid,
  horizontalPlpProducts = [],
  fetchedProductLength,
}) {
  const loadMoreRef = useRef(horizontalPlpProducts?.length > fetchedProductLength);
  const removeEventListener = (callback) => {
    document.removeEventListener('scroll', callback);
  };
  /**
   * This handler gets registered, once currentCid changes. currentCid set after first set of product is fetched for hlp
   * Gets called on every scroll, but gets deregistered once fetch call gets executed
   * deregisters the event listener. Scroll event listener get registered again, every time currentCid changes
   */
  const handleHlpScroll = () => {
    if (loadMoreRef.current) {
      getMoreHorizontalCategoryActn();
      removeEventListener(handleHlpScroll);
    }
  };

  useEffect(() => {
    loadMoreRef.current = horizontalPlpProducts?.length > fetchedProductLength;
  }, [horizontalPlpProducts]);

  useEffect(() => {
    document.addEventListener('scroll', handleHlpScroll);
    return () => removeEventListener(handleHlpScroll); // gets called when user has not scrolled, but changed currentCid
  }, [currentCid, fetchedProductLength]);
}
export default useFetchOnScroll;
